import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { EcomValidator } from 'src/app/ecom-services/ecom-validation';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { Router } from '@angular/router';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';

@Component({
  selector: 'app-ecom-changepassword',
  templateUrl: './ecom-changepassword.component.html',
  styleUrls: ['./ecom-changepassword.component.scss']
})
export class EcomChangepasswordComponent implements OnInit {
  // component class properties
  public userForm: FormGroup;
  successMessage: any;
  errorMessage: any;
  redirect = false;
  active = 0;
  // constructor to inject the class objects
  constructor(private eComGoogleAnalytics:EComGoogleAnalytics,public formBuilder: FormBuilder, public ecomservice: EComService, private cookie: EcomCookies,
    private webstorage: EComWebStorage, public router: Router) { }

  // component initialize and load the required data
  ngOnInit() {
    let gTag = {
      'event':'screen_view',
      'screen_name':'change password'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    if(!this.webstorage.sessionSt_is_session_valid){
      this.router.navigate(['home']);
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.userForm = this.formBuilder.group({
      currentpassword: ['', Validators.compose([Validators.required, EcomValidator.passwordValidator])],
      newpassword: ['', Validators.compose([Validators.required, EcomValidator.passwordValidator])],
      confirmpassword: ['', Validators.compose([Validators.required, EcomValidator.passwordValidator])]
    });
    this.LoadPage();
  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.getUser();
        }
      });
    } else {
      this.getUser();
    }
  }

  // Method to get the user based on userid
  getUser() {
    const userId = this.webstorage.localSt_user_id;
    this.ecomservice.httpGet(EcomNetworkUtils.GET_PROFILE + '?Id=' + userId, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
        } else {
          this.router.navigate(['login']);
          this.ecomservice.commonLoading.show = false;
        }
      }
    });
  }

  passwordMatch(event) {
    // const newPassword = this.userForm.value.newpassword;
    // const confirmPassword = event.target.value;
    // if (newPassword !== confirmPassword) {
    //   this.userForm.controls.confirmpassword.setErrors({ 'match': false });
    // } else {

    // }
    // this.userForm.updateValueAndValidity();
  }


  // Method to handle the change password click event
  onChangePasswordClick() {
    this.active = 1;
    this.successMessage = undefined;
    this.errorMessage = undefined;
    if (this.userForm.invalid) {
      Object.keys(this.userForm.controls).forEach(key => {
        this.userForm.get(key).markAsDirty();
      });
      return;
    } else {
      const input = {
        'ooc_guid': this.webstorage.localSt_user_id,
        'currentPassword': this.ecomservice.encryptWithKey(this.userForm.value.currentpassword),
        'newPassword': this.ecomservice.encryptWithKey(this.userForm.value.newpassword),
        'confirmPassword': this.ecomservice.encryptWithKey(this.userForm.value.confirmpassword),
        customer_client_key: this.webstorage.localSt_client_id,
        customer_key: this.webstorage.localSt_olar_key
      };
      this.ecomservice.httpPost(EcomNetworkUtils.POST_PROFILE_PASSWORD_CHANGE, input, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            this.successMessage = response.msg;
            this.redirectUser(5);
          } else {
            this.errorMessage = response.msg;
          }
        }
        this.active = 0;
      });
    }
  }

  // Method to autoredirect the user after password change
  redirectUser(remaining) {
    this.redirect = true;
    //redirect
    let m = Math.floor(remaining / 60);
    let s = remaining % 60;
    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    if (document.getElementById('redirect')) {
      document.getElementById('redirect').innerHTML = ('0' + m).slice(-2) + ' : ' + ('0' + s).slice(-2);
    }
    remaining -= 1;
    if (remaining >= 0 && this.redirect) {
      let temp = this;
      setTimeout(function () {
        temp.redirectUser(remaining);
      }, 1000);
      return;
    }
    this.redirect = false;
    this.webstorage.localSt_user_id = undefined;
    this.cookie.delete_cookie('authtoken');
    this.router.navigate(['login']);
  }

  // Method to handle the back button click
  onBackClick() {
    if (this.webstorage.sessionSt_frompage) {
      this.router.navigate([this.webstorage.sessionSt_frompage]);
    } else {
      this.router.navigate(['login']);
    }
  }

}
